var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.48 3.395l2.122 2.12-7.82 7.812L2 14l.659-2.793 7.821-7.812zm0 1.414l-6.506 6.498.707.707 6.505-6.498-.706-.707zM12.497 2c.284 0 .557.078.795.227l.129.09.14.12.12.14.022.03c.366.492.394 1.147.082 1.664l-.067.102-.024.033-.027.032-.34.353-2.123-2.12.233-.231c.283-.284.66-.44 1.06-.44z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconEdit.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };